import PropTypes from 'prop-types';
import BarLoader from 'react-spinners/BarLoader';

const Loader = ({ isLoading }) => {
	return (
		<section className={isLoading === true ? 'loader loader--loading' : 'loader'}>
			<BarLoader height={8} width={150} color={'#ffffff'} />
		</section>
	);
};

Loader.propTypes = {
	isLoading: PropTypes.bool,
};

export default Loader;
